<template>
  <div class="flex items-center px-2 text-sm">
    <UtilButton
      @click="switchLayout('card')"
      :color="layout === 'card' ? 'brand' : 'secondary'"
      class="mr-4"
      textLink
    >
      <FontAwesomeIcon v-if="$breakpoint.xs" :icon="faImages" />
      <FontAwesomeIcon v-else :icon="faTh" />
      <span class="text-sm sm:text-base">{{ $breakpoint.xs ? $t('search.cards') : $t('search.grid') }}</span>
    </UtilButton>

    <UtilButton @click="switchLayout('list')" :color="layout === 'list' ? 'brand' : 'secondary'" textLink>
      <FontAwesomeIcon v-if="$breakpoint.xs" :icon="faList" />
      <FontAwesomeIcon v-else :icon="faThList" />
      <span class="text-sm sm:text-base">{{ $t('search.list') }}</span>
    </UtilButton>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { faTh, faThList } from '@fortawesome/pro-solid-svg-icons'
import { faImages, faList } from '@fortawesome/pro-regular-svg-icons'
import UtilButton from '@/components/utils/UtilButton'

export default {
  name: 'UtilSearchLayoutToggle',
  components: {
    UtilButton
  },
  data() {
    return {
      faTh,
      faList,
      faThList,
      faImages
    }
  },
  computed: {
    ...mapState({
      layout: state => state.search.layout
    })
  },
  methods: {
    switchLayout(layout) {
      this.$store.commit('search/setLayout', layout)

      this.$analytics.addEvent({
        category: 'search',
        action: 'Switch results layout',
        label: layout
      })
    }
  }
}
</script>
